import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { GoPencil } from "react-icons/go";
import { Formik } from "formik";
import { Form, Field } from "formik";

import * as Yup from "yup";
import { Bounce, toast } from "react-toastify";

const Dashboard = () => {
  const [res, setRes] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [editMode1, setEditMode1] = useState(false);
  const [editSection1, setEditSection1] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editSection4, setEditSection4] = useState(false);
  const [userImage, setUserImage] = useState("");
  const [userImagePreview, setUserImagePreview] = useState("");
  const [previewImage1, setPreviewImage1] = useState({});
  const [previewImage2, setPreviewImage2] = useState({});
  const [images1, setImages1] = useState([]);
  const [images2, setImages2] = useState([]);
  const [previewImages, setPreviewImages] = useState({});
  const [brandImgs, setBrandImgs] = useState({});
  const [loading, setLoading] = useState(false);
  const [heroVideo, setHeroVideo] = useState("");
  const [heroVideoPreview, setHeroVideoPreview] = useState("");
  const token = localStorage.getItem("hiedberg_admin_token");

  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/home/get`
      );
      console.log("Fetched result:", result.data.data);
      setRes(result.data.data);
    } catch (error) {
      console.error("Error fetching :", error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange3 = (e, index, field) => {
    console.log(index);
    const file = e.target.files[0];
    if (!file) return;
    const previewURL = URL.createObjectURL(file);
    if (field === "imageUrl1") {
      setPreviewImage1((prev) => {
        return {
          ...prev,
          [index]: previewURL,
        };
      });

      setImages1((prev) => {
        return {
          ...prev,
          [index]: file,
        };
      });
    } else if (field === "imageUrl2") {
      setPreviewImage2((prev) => {
        return {
          ...prev,
          [index]: previewURL,
        };
      });
      setImages2((prev) => {
        return {
          ...prev,
          [index]: file,
        };
      });
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setUserImage(file);
      setUserImagePreview(imageUrl);
    }
  };
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const videoUrl = URL.createObjectURL(file);
      setHeroVideo(file);
      setHeroVideoPreview(videoUrl);
    }
  };

  const initialValues = {
    title1: res.hero?.title1 || "",
    title2: res.hero?.title2 || "",
    description: res.hero?.description || "",
    buttonText: res.hero?.buttonText || "",
    brandTitle: res.hero?.brands?.title || "",
    brandUrls: [
      res.hero?.brands?.brands?.[0]?.url || "",
      res.hero?.brands?.brands?.[1]?.url || "",
      res.hero?.brands?.brands?.[2]?.url || "",
    ],
    videoUrl: res.hero?.videoUrl || "",
  };
  const initialValues1 = {
    title1: res.section2?.title1 || "",
    title2: res.section2?.title2 || "",
    message: res.section2?.message || "",
    name: res.section2?.user?.name || "",
    designation: res.section2?.user?.designation || "",
  };
  const validationSchema1 = Yup.object({
    title1: Yup.string().required("Title 1 is required"),
    title2: Yup.string().required("Title 2 is required"),
    message: Yup.string().required("Message is required"),
    name: Yup.string().required("Name is required"),
    designation: Yup.string().required("Designation is required"),
  });
  const validationSchema = Yup.object().shape({
    title1: Yup.string().required("Title 1 is required"),
    title2: Yup.string().required("Title 2 is required"),
    description: Yup.string().required("Description is required"),
    buttonText: Yup.string().required("Button Text is required"),
    brandTitle: Yup.string().required("Brand Title is required"),
    brandUrls: Yup.array()
      .of(
        Yup.string()
          .url("Please add http or https in URL")
          .required("Brand URL is required")
      )
      .required("Brand URLs are required"),
    videoUrl: Yup.string().url("Please add http or https in URL"),
  });
  const initialSection1Values = {
    title: res?.section1?.title || "",
    description: res?.section1?.description || "",
  };
  const section1ValidationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
  });
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const brandBg = {};
      const logo = {};

      const uploadPromises = [];

      for (let i = 0; i < 3; i++) {
        if (previewImages[i]) {
          const bgPromise = (async () => {
            const fileInput = document.getElementById(`brandImageInput-${i}`);
            const file = fileInput?.files?.[0];
            if (file) {
              const formData = new FormData();
              formData.append("file", file);
              const uploadRes = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/upload`,
                formData
              );
              brandBg[i] = uploadRes.data.data.publicUrl;
            }
          })();
          uploadPromises.push(bgPromise);
        }

        if (brandImgs[i]) {
          const logoPromise = (async () => {
            const fileInput = document.getElementById(`brandLogo-${i}`);
            const file = fileInput?.files?.[0];
            if (file) {
              const formData = new FormData();
              formData.append("file", file);
              const uploadRes = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/upload`,
                formData
              );
              logo[i] = uploadRes.data.data.publicUrl;
            }
          })();
          uploadPromises.push(logoPromise);
        }
      }

      if (heroVideo) {
        const videoPromise = (async () => {
          const formData = new FormData();
          formData.append("file", heroVideo);
          const uploadRes = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/upload`,
            formData
          );
          return uploadRes.data.data.publicUrl;
        })();
        uploadPromises.push(videoPromise);
      }

      const uploadResults = await Promise.all(uploadPromises);
      const uploadedVideoUrl = heroVideo
        ? uploadResults[uploadResults.length - 1]
        : res.hero?.videoUrl || "";

      const brands = [0, 1, 2].map((i) => ({
        imageUrl: brandBg[i] || res.hero?.brands?.brands?.[i]?.imageUrl || "",
        url: values.brandUrls[i],
        logo: logo[i] || res.hero?.brands?.brands?.[i]?.logo || "",
      }));

      const payload = {
        hero: {
          title1: values.title1?.trim() || "",
          title2: values.title2?.trim() || "",
          description: values.description?.trim() || "",
          buttonText: values.buttonText?.trim() || "",
          videoUrl: uploadedVideoUrl,
          brands: {
            title: values.brandTitle?.trim() || "",
            brands: brands,
          },
        },
      };

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/home/update`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setPreviewImages({});
      setBrandImgs({});
      setHeroVideo("");
      setHeroVideoPreview("");
      fetchData();
      setEditMode(false);
      toast.success("Hero section updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Failed to update Hero section:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit1 = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/home/update`,
        {
          section1: {
            title: values.title,
            description: values.description,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("API Success:", response.data);
      fetchData();
      setEditSection1(false);
      toast.success("Section 1 updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("API Error:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitSection2 = async (values) => {
    try {
      setLoading(true);
      let uploadedImageUrl = res.section2?.user?.imageUrl;

      // Upload only if new file selected
      if (userImage) {
        const formData = new FormData();
        formData.append("file", userImage);

        console.log("Uploading image:", formData);
        const uploadRes = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/upload`,
          formData
        );
        uploadedImageUrl = uploadRes.data?.data?.publicUrl;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/home/update`,
        {
          section2: {
            title1: values.title1,
            title2: values.title2,
            message: values.message,
            user: {
              name: values.name,
              designation: values.designation,
              imageUrl: uploadedImageUrl,
            },
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchData();
      console.log("Section 2 updated successfully:", response.data);
      toast.success("Section 2 updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      setEditMode1(false);
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error(
        "Section 2 update failed:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit3 = async (values, index) => {
    try {
      setLoading(true);
      let uploadedImageUrl1 = section3[index].imageUrl1;
      let uploadedImageUrl2 = section3[index].imageUrl2;
      if (previewImage1[index]) {
        const formData = new FormData();
        formData.append("file", images1[index]);

        const uploadRes1 = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/upload`,
          formData
        );
        uploadedImageUrl1 = uploadRes1.data.data.publicUrl;
      }
      if (previewImage2[index]) {
        const formData = new FormData();
        formData.append("file", images2[index]);

        const uploadRes2 = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/upload`,
          formData
        );
        uploadedImageUrl2 = uploadRes2.data.data.publicUrl;
      }
      const updatedSection3 = section3.map((item, i) =>
        i === index
          ? {
              ...item,
              title: values.title,
              description: values.description,
              buttonText: values.buttonText,
              buttonUrl: values.buttonUrl,
              imageUrl1: uploadedImageUrl1,
              imageUrl2: uploadedImageUrl2,
            }
          : item
      );

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/home/update`,
        { section3: updatedSection3 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Section 3 updated:", response.data);
      fetchData();
      setEditIndex(null);
      toast.success("Section 3 updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Update failed:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitSection4 = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/home/update`,
        {
          section4: {
            title1: values.title1,
            title2: values.title2,
            description: values.description,
            buttonText: values.buttonText,
            buttonUrl: values.buttonUrl,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Section 4 update success:", response.data);
      setEditSection4(false);
      fetchData();
      toast.success("Section 4 updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error(
        "Section 4 update failed:",
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };
  const initialValues4 = {
    title1: res.section4?.title1 || "",
    title2: res.section4?.title2 || "",
    description: res.section4?.description || "",
    buttonText: res.section4?.buttonText || "",
    buttonUrl: res.section4?.buttonUrl || "",
  };
  const validationSchema4 = Yup.object().shape({
    title1: Yup.string().required("Title 1 is required"),
    title2: Yup.string().required("Title 2 is required"),
    description: Yup.string().required("Description is required"),
    buttonText: Yup.string().required("Button Text is required"),
    buttonUrl: Yup.string()
      .url("Please add http or https in URL")
      .required("Button Url is required"),
  });
  const section3 = res?.section3 || [];
  const validationSchema3 = Yup.object({
    title: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
    buttonText: Yup.string().required("Required"),
    buttonUrl: Yup.string()
      .url("Please add http or https in URL")
      .required("Required"),
  });
  const handleImageChange1 = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImages((prev) => ({ ...prev, [index]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };
  const handleImageChange2 = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBrandImgs((prev) => ({ ...prev, [index]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        <div className="flex justify-center py-10">
          <div className="h-6 w-6 animate-spin rounded-full border-t-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="mt-5 space-y-4 overflow-auto pb-6">
          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, handleChange, resetForm }) => (
                <Form className="flex flex-col gap-y-4">
                  <div className="flex justify-between">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Hero Section
                    </h3>
                    {editMode ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="submit"
                          onClick={() => {
                            setEditMode(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setEditMode(true)}
                      />
                    )}
                  </div>
                  <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Hero Video
                    </h3>
                    <div className="flex flex-col gap-4">
                      <div className="group relative h-64 w-full overflow-hidden rounded-lg border border-gray-300">
                        {heroVideoPreview || res.hero?.videoUrl ? (
                          <video
                            src={heroVideoPreview || res.hero?.videoUrl}
                            className="h-full w-full object-cover"
                            controls
                            muted
                            autoPlay
                          />
                        ) : (
                          <div className="flex h-full w-full items-center justify-center bg-gray-100">
                            <span className="text-gray-500">
                              No video uploaded
                            </span>
                          </div>
                        )}
                        {editMode && (
                          <>
                            <div className="bg-green absolute inset-0 flex items-center justify-center bg-[#353935] bg-opacity-65 opacity-0 transition duration-300 group-hover:opacity-100">
                              <GoPencil
                                className="h-7 w-7 cursor-pointer text-white"
                                onClick={() =>
                                  document
                                    .getElementById("heroVideoInput")
                                    .click()
                                }
                              />
                            </div>
                            <input
                              type="file"
                              id="heroVideoInput"
                              accept="video/*"
                              className="hidden"
                              onChange={handleVideoChange}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <TextField
                    name="title1"
                    label="Title 1"
                    size="small"
                    variant="outlined"
                    value={values.title1}
                    onChange={handleChange}
                    disabled={!editMode}
                    error={touched.title1 && Boolean(errors.title1)}
                    helperText={touched.title1 && errors.title1}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                  <TextField
                    name="title2"
                    label="Title 2"
                    size="small"
                    variant="outlined"
                    value={values.title2}
                    onChange={handleChange}
                    disabled={!editMode}
                    error={touched.title2 && Boolean(errors.title2)}
                    helperText={touched.title2 && errors.title2}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                  <TextField
                    name="description"
                    label="Description"
                    size="small"
                    variant="outlined"
                    value={values.description}
                    onChange={handleChange}
                    disabled={!editMode}
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                  <TextField
                    name="buttonText"
                    label="Button Text"
                    size="small"
                    variant="outlined"
                    value={values.buttonText}
                    onChange={handleChange}
                    disabled={!editMode}
                    error={touched.buttonText && Boolean(errors.buttonText)}
                    helperText={touched.buttonText && errors.buttonText}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                  <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Brand's Section
                    </h3>
                    <TextField
                      name="brandTitle"
                      label="Title"
                      size="small"
                      variant="outlined"
                      value={values.brandTitle}
                      onChange={handleChange}
                      disabled={!editMode}
                      error={touched.brandTitle && Boolean(errors.brandTitle)}
                      helperText={touched.brandTitle && errors.brandTitle}
                      slotProps={{ inputLabel: { shrink: true } }}
                    />
                    <p className="mt-2 text-base font-semibold text-gray-800">
                      Brands
                    </p>
                    <div className="flex flex-wrap gap-4 sm:flex-nowrap">
                      {[0, 1, 2].map((i) => (
                        <div
                          key={i}
                          className="group relative w-full rounded-xl border border-gray-300 bg-white p-4 shadow-sm sm:w-1/3"
                        >
                          <div className="h-30 group relative mb-4 w-full overflow-hidden rounded-lg">
                            <img
                              src={
                                brandImgs[i] ||
                                `${res.hero?.brands?.brands?.[i]?.logo}`
                              }
                              className="h-full w-full object-cover"
                              alt={`brandLogo-${i}`}
                            />
                            {editMode && (
                              <>
                                <div className="bg-green absolute inset-0 flex items-center justify-center bg-[#353935] bg-opacity-65 opacity-0 transition duration-300 group-hover:opacity-100">
                                  <GoPencil
                                    className="h-7 w-7 cursor-pointer text-white"
                                    onClick={() =>
                                      document
                                        .getElementById(`brandLogo-${i}`)
                                        .click()
                                    }
                                  />
                                </div>
                                <input
                                  type="file"
                                  id={`brandLogo-${i}`}
                                  accept="image/*"
                                  className="hidden"
                                  onChange={(e) => handleImageChange2(e, i)}
                                />
                              </>
                            )}
                          </div>
                          <div className="h-30 group relative mb-4 w-full overflow-hidden rounded-lg">
                            <img
                              src={
                                previewImages[i] ||
                                `${res.hero?.brands?.brands?.[i]?.imageUrl}`
                              }
                              className="h-full w-full object-cover"
                              alt={`brand-${i}`}
                            />
                            {editMode && (
                              <>
                                <div className="bg-green absolute inset-0 flex items-center justify-center bg-[#353935] bg-opacity-65 opacity-0 transition duration-300 group-hover:opacity-100">
                                  <GoPencil
                                    className="h-7 w-7 cursor-pointer text-white"
                                    onClick={() =>
                                      document
                                        .getElementById(`brandImageInput-${i}`)
                                        .click()
                                    }
                                  />
                                </div>
                                <input
                                  type="file"
                                  id={`brandImageInput-${i}`}
                                  accept="image/*"
                                  className="hidden"
                                  onChange={(e) => handleImageChange1(e, i)}
                                />
                              </>
                            )}
                          </div>
                          <TextField
                            name={`brandUrls[${i}]`}
                            label="Url"
                            size="small"
                            variant="outlined"
                            fullWidth
                            value={values.brandUrls[i]}
                            onChange={handleChange}
                            disabled={!editMode}
                            error={
                              touched.brandUrls?.[i] &&
                              Boolean(errors.brandUrls?.[i])
                            }
                            helperText={
                              touched.brandUrls?.[i] && errors.brandUrls?.[i]
                            }
                            slotProps={{ inputLabel: { shrink: true } }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <Formik
            enableReinitialize
            initialValues={initialSection1Values}
            validationSchema={editSection1 ? section1ValidationSchema : null}
            onSubmit={handleSubmit1}
          >
            {({
              values,
              handleChange,
              handleBlur,
              touched,
              errors,
              resetForm,
            }) => (
              <Form>
                <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                  <div>
                    <div className="flex justify-between">
                      <h3 className="mb-4 text-lg font-semibold text-gray-800">
                        Section 1
                      </h3>
                      {editSection1 ? (
                        <div className="flex items-center gap-3">
                          <button
                            type="submit"
                            className="text-sm font-medium text-blue-600 hover:text-blue-800"
                          >
                            Save Changes
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setEditSection1(false);
                              resetForm();
                            }}
                            className="text-sm font-medium text-gray-500 hover:text-gray-700"
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <GoPencil
                          className="hover:text-black h-5 w-5 cursor-pointer"
                          onClick={() => setEditSection1(true)}
                        />
                      )}
                    </div>
                    <div className="flex flex-col gap-y-4">
                      <TextField
                        name="title"
                        label="Title 1"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.title}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!editSection1}
                        error={touched.title && Boolean(errors.title)}
                        helperText={touched.title && errors.title}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        name="description"
                        label="Description"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={!editSection1}
                        error={
                          touched.description && Boolean(errors.description)
                        }
                        helperText={touched.description && errors.description}
                        InputLabelProps={{ shrink: true }}
                        multiline
                        minRows={3}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <Formik
            initialValues={initialValues1}
            validationSchema={validationSchema1}
            enableReinitialize
            onSubmit={handleSubmitSection2}
          >
            {({ errors, touched, resetForm }) => (
              <Form>
                <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                  <div>
                    <div className="flex justify-between">
                      <h3 className="mb-4 text-lg font-semibold text-gray-800">
                        Section 2
                      </h3>
                      {editMode1 ? (
                        <div className="flex items-center gap-3">
                          <button
                            type="submit"
                            className="text-sm font-medium text-blue-600 hover:text-blue-800"
                          >
                            Save Changes
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setEditMode1(false);
                              resetForm();
                            }}
                            className="text-sm font-medium text-gray-500 hover:text-gray-700"
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <GoPencil
                          className="hover:text-black h-5 w-5 cursor-pointer"
                          onClick={() => setEditMode1(true)}
                        />
                      )}
                    </div>
                    <div className="flex flex-col gap-y-4">
                      <Field
                        name="title1"
                        as={TextField}
                        label="Title 1"
                        size="small"
                        variant="outlined"
                        fullWidth
                        disabled={!editMode1}
                        error={touched.title1 && Boolean(errors.title1)}
                        helperText={touched.title1 && errors.title1}
                        InputLabelProps={{ shrink: true }}
                      />
                      <Field
                        name="title2"
                        as={TextField}
                        label="Title 2"
                        size="small"
                        variant="outlined"
                        fullWidth
                        disabled={!editMode1}
                        error={touched.title2 && Boolean(errors.title2)}
                        helperText={touched.title2 && errors.title2}
                        InputLabelProps={{ shrink: true }}
                      />
                      <Field
                        name="message"
                        as={TextField}
                        label="Message"
                        size="small"
                        variant="outlined"
                        fullWidth
                        disabled={!editMode1}
                        error={touched.message && Boolean(errors.message)}
                        helperText={touched.message && errors.message}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                  </div>
                  <div className="mt-5 rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      User
                    </h3>
                    <div className="flex flex-col gap-y-4">
                      <div className="group relative h-24 w-24 rounded-xl border border-gray-300 bg-white p-1 shadow-sm">
                        <input
                          type="file"
                          accept="image/*"
                          id="user-image-upload"
                          className="hidden"
                          onChange={handleImageChange}
                        />
                        <img
                          src={
                            userImagePreview
                              ? userImagePreview
                              : `${res.section2?.user?.imageUrl}`
                          }
                          className="h-full w-full rounded-lg object-cover"
                          alt="User"
                        />
                        {editMode1 && (
                          <label
                            htmlFor="user-image-upload"
                            className="bg-black absolute inset-0  flex cursor-pointer items-center justify-center rounded-lg bg-[#353935] bg-opacity-65 text-white opacity-0 transition group-hover:opacity-100"
                          >
                            <GoPencil className="h-5 w-5" />
                          </label>
                        )}
                      </div>
                      <Field
                        name="name"
                        as={TextField}
                        label="Name"
                        size="small"
                        variant="outlined"
                        fullWidth
                        disabled={!editMode1}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        InputLabelProps={{ shrink: true }}
                      />
                      <Field
                        name="designation"
                        as={TextField}
                        label="Designation"
                        size="small"
                        variant="outlined"
                        fullWidth
                        disabled={!editMode1}
                        error={
                          touched.designation && Boolean(errors.designation)
                        }
                        helperText={touched.designation && errors.designation}
                        InputLabelProps={{ shrink: true }}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <div>
              <div className="flex justify-between">
                <h3 className="mb-4 text-lg font-semibold text-gray-800">
                  Section 3
                </h3>
              </div>
              <div className="grid grid-cols-12 gap-y-4">
                {section3.map((item, index) => (
                  <div
                    key={index}
                    className="col-span-12 space-y-4 rounded-xl border border-gray-300 bg-white p-4 shadow-sm"
                  >
                    <Formik
                      initialValues={{
                        title: item.title || "",
                        description: item.description || "",
                        buttonText: item.buttonText || "",
                        buttonUrl: item.buttonUrl || "",
                      }}
                      validationSchema={validationSchema3}
                      enableReinitialize
                      onSubmit={(values) => handleSubmit3(values, index)}
                    >
                      {({
                        errors,
                        touched,
                        values,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        resetForm,
                      }) => (
                        <Form className="space-y-4" onSubmit={handleSubmit}>
                          <div className="flex justify-end">
                            {editIndex === index ? (
                              <div className="flex items-center gap-3">
                                <button
                                  type="submit"
                                  className="text-sm font-medium text-blue-600 hover:text-blue-800"
                                >
                                  Save Changes
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setEditIndex(null);
                                    resetForm();
                                  }}
                                  className="text-sm font-medium text-gray-500 hover:text-gray-700"
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              <GoPencil
                                className="hover:text-black h-5 w-5 cursor-pointer"
                                onClick={() => setEditIndex(index)}
                              />
                            )}
                          </div>
                          <TextField
                            name="title"
                            label="Title"
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={values.title}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.title && Boolean(errors.title)}
                            helperText={touched.title && errors.title}
                            disabled={editIndex !== index}
                          />
                          <TextField
                            name="description"
                            label="Description"
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              touched.description && Boolean(errors.description)
                            }
                            helperText={
                              touched.description && errors.description
                            }
                            disabled={editIndex !== index}
                          />
                          <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-3 hidden flex-col rounded-xl border border-gray-300 bg-white p-4 shadow-sm sm:flex">
                              <div className="group relative col-span-3 flex flex-col rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                                <p className="mb-2">Image 1</p>

                                <div className="relative h-72 w-full overflow-hidden rounded-lg">
                                  <img
                                    src={
                                      previewImage1?.[index] ||
                                      `${item.imageUrl1}`
                                    }
                                    className="h-full w-full rounded-lg object-cover"
                                    alt="Image 1"
                                  />

                                  {editIndex === index && (
                                    <>
                                      <label
                                        htmlFor={`user-image-upload-${index}`}
                                        className="bg-black absolute inset-0  flex cursor-pointer items-center justify-center rounded-lg bg-[#353935] bg-opacity-65 text-white opacity-0 transition duration-300 group-hover:opacity-100"
                                      >
                                        <GoPencil className="h-6 w-6" />
                                      </label>
                                      <input
                                        id={`user-image-upload-${index}`}
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        onChange={(e) =>
                                          handleImageChange3(
                                            e,
                                            index,
                                            "imageUrl1"
                                          )
                                        }
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-span-12 flex flex-col rounded-xl border border-gray-300 bg-white p-4 shadow-sm sm:col-span-9">
                              <div className="relative col-span-12 flex flex-col rounded-xl border border-gray-300 bg-white p-4 shadow-sm sm:col-span-9">
                                <p className="mb-2">Image 2</p>
                                <div className="group relative h-72 w-full overflow-hidden rounded-lg">
                                  <img
                                    src={
                                      previewImage2?.[index] ||
                                      `${item.imageUrl2}`
                                    }
                                    className="h-full w-full rounded-lg object-cover"
                                    alt="Image 2"
                                  />
                                  {editIndex === index && (
                                    <>
                                      <label
                                        htmlFor={`image-upload-${index}`}
                                        className="bg-black absolute inset-0  flex cursor-pointer items-center justify-center rounded-lg bg-[#353935]  bg-opacity-65 text-white opacity-0 transition duration-300 group-hover:opacity-100"
                                      >
                                        <GoPencil className="h-6 w-6" />
                                      </label>
                                      <input
                                        id={`image-upload-${index}`}
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        onChange={(e) =>
                                          handleImageChange3(
                                            e,
                                            index,
                                            "imageUrl2"
                                          )
                                        }
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <TextField
                            name="buttonText"
                            label="Button Text"
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={values.buttonText}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              touched.buttonText && Boolean(errors.buttonText)
                            }
                            helperText={touched.buttonText && errors.buttonText}
                            disabled={editIndex !== index}
                          />
                          <TextField
                            name="buttonUrl"
                            label="Button Url"
                            variant="outlined"
                            size="small"
                            fullWidth
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={values.buttonUrl}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              touched.buttonUrl && Boolean(errors.buttonUrl)
                            }
                            helperText={touched.buttonUrl && errors.buttonUrl}
                            disabled={editIndex !== index}
                          />
                        </Form>
                      )}
                    </Formik>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Formik
            enableReinitialize
            initialValues={initialValues4}
            validationSchema={editSection4 ? validationSchema4 : null}
            onSubmit={handleSubmitSection4}
          >
            {({ values, errors, touched, handleChange, resetForm }) => (
              <Form>
                <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                  <div className="flex items-center justify-between">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Section 4
                    </h3>
                    {editSection4 ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setEditSection4(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setEditSection4(true)}
                      />
                    )}
                  </div>
                  <div className="flex flex-col gap-y-4">
                    <TextField
                      label="Title 1"
                      name="title1"
                      variant="outlined"
                      size="small"
                      value={values.title1}
                      onChange={handleChange}
                      error={touched.title1 && Boolean(errors.title1)}
                      helperText={touched.title1 && errors.title1}
                      disabled={!editSection4}
                    />
                    <TextField
                      label="Title 2"
                      name="title2"
                      variant="outlined"
                      size="small"
                      value={values.title2}
                      onChange={handleChange}
                      error={touched.title2 && Boolean(errors.title2)}
                      helperText={touched.title2 && errors.title2}
                      disabled={!editSection4}
                    />
                    <TextField
                      label="Description"
                      name="description"
                      variant="outlined"
                      size="small"
                      value={values.description}
                      onChange={handleChange}
                      error={touched.description && Boolean(errors.description)}
                      helperText={touched.description && errors.description}
                      disabled={!editSection4}
                    />
                    <TextField
                      label="Button Text"
                      name="buttonText"
                      variant="outlined"
                      size="small"
                      value={values.buttonText}
                      onChange={handleChange}
                      error={touched.buttonText && Boolean(errors.buttonText)}
                      helperText={touched.buttonText && errors.buttonText}
                      disabled={!editSection4}
                    />
                    <TextField
                      label="Button Url"
                      name="buttonUrl"
                      variant="outlined"
                      size="small"
                      value={values.buttonUrl}
                      onChange={handleChange}
                      error={touched.buttonUrl && Boolean(errors.buttonUrl)}
                      helperText={touched.buttonUrl && errors.buttonUrl}
                      disabled={!editSection4}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
    </>
  );
};

export default Dashboard;
